/*
 * Custom migrated scripts from Backup Alori.
 * Phase 1 only: isolated store-specific behavior and dormant hooks.
 * Updated Alori / Shapes 4.3.1 remains the source of truth.
 * Sticky ATC removed — replaced by snippets/sticky-atc.liquid
 */

(() => {
  const BLOG_SCROLL_RATIO = 0.85;

  function initBlogCarousel(track) {
    if (!track || track.dataset.customMigratedBlogCarousel === 'true') {
      return;
    }

    const scope = track.closest('.shopify-section, section, [id]') || document;
    const sectionId =
      track.id && track.id.indexOf('blog-carousel-') === 0
        ? track.id.replace('blog-carousel-', '')
        : track.dataset.sectionId;
    const dotsContainer = sectionId
      ? document.getElementById(`dots-${sectionId}`)
      : scope.querySelector('.blog-carousel-dots');
    const items = Array.from(track.querySelectorAll('.blog-carousel-item'));

    if (!dotsContainer || !items.length) {
      return;
    }

    const dots = Array.from(dotsContainer.querySelectorAll('.blog-carousel-dot'));
    const prevButton = scope.querySelector('.blog-carousel-prev');
    const nextButton = scope.querySelector('.blog-carousel-next');

    const updateActiveDot = () => {
      const itemWidth = items[0] ? items[0].offsetWidth + 16 : 1;
      const activeIndex = Math.round(track.scrollLeft / itemWidth);

      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === activeIndex);
      });
    };

    dotsContainer.addEventListener('click', (event) => {
      const dot = event.target.closest('.blog-carousel-dot');
      if (!dot) {
        return;
      }

      const index = Number.parseInt(dot.dataset.index || '', 10);
      if (Number.isNaN(index) || !items[index]) {
        return;
      }

      track.scrollTo({
        left: items[index].offsetLeft - track.offsetLeft,
        behavior: 'smooth',
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        track.scrollBy({
          left: -track.offsetWidth * BLOG_SCROLL_RATIO,
          behavior: 'smooth',
        });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        track.scrollBy({
          left: track.offsetWidth * BLOG_SCROLL_RATIO,
          behavior: 'smooth',
        });
      });
    }

    track.addEventListener('scroll', updateActiveDot, { passive: true });
    track.dataset.customMigratedBlogCarousel = 'true';
    updateActiveDot();
  }

  function initBlogCarousels(root) {
    root
      .querySelectorAll('[id^="blog-carousel-"], .blog-carousel-track')
      .forEach(initBlogCarousel);
  }

  function initProductThumbnailRail(rail) {
    if (!rail || rail.dataset.customMigratedThumbRail === 'true') {
      return;
    }

    const syncActiveThumbnail = () => {
      const activeThumbnail = rail.querySelector(
        '.product-thumbnail-list-item--active'
      );

      if (!activeThumbnail) {
        return;
      }

      activeThumbnail.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    };

    if ('MutationObserver' in window) {
      const observer = new MutationObserver((mutations) => {
        const classChanged = mutations.some(
          (mutation) =>
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class' &&
            mutation.target instanceof Element &&
            mutation.target.classList.contains('product-thumbnail-list-item')
        );

        if (classChanged) {
          syncActiveThumbnail();
        }
      });

      observer.observe(rail, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    rail.querySelectorAll('.product-thumbnail-list-item').forEach((item) => {
      item.addEventListener('click', () => {
        window.requestAnimationFrame(syncActiveThumbnail);
      });
    });

    rail.dataset.customMigratedThumbRail = 'true';
    syncActiveThumbnail();
  }

  function initProductThumbnailRails(root) {
    root
      .querySelectorAll('.alori-thumb-strip, .alori-mobile-thumb-strip')
      .forEach(initProductThumbnailRail);
  }

  function initCurvedTextWave(waveWrapper) {
    if (!waveWrapper || waveWrapper.dataset.customMigratedWave === 'true') {
      return;
    }

    const suffix = waveWrapper.id.replace('alori-wave-', '');
    if (!suffix) {
      return;
    }

    const section = document.getElementById(suffix) || waveWrapper.parentElement;
    const waveSvg = document.getElementById(`alori-wave-svg-${suffix}`);

    if (!section || !waveSvg) {
      return;
    }

    section.style.position = section.style.position || 'relative';
    waveSvg.style.transform = 'translateX(-800px)';
    waveWrapper.dataset.customMigratedWave = 'true';
  }

  function initCurvedTextWaves(root) {
    root.querySelectorAll('[id^="alori-wave-"]').forEach((waveWrapper) => {
      initCurvedTextWave(waveWrapper);
    });
  }

  function run(root) {
    initBlogCarousels(root);
    initProductThumbnailRails(root);
    initCurvedTextWaves(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(document));
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) {
      run(event.target);
    }
  });
})();
